var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.45 16.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.48,16.78H11.54a.52.52,0,0,1-.54-.5V12.34a.88.88,0,0,0-.91-.83H8.35a.87.87,0,0,0-.9.83v3.94a.51.51,0,0,1-.54.49H4A1.91,1.91,0,0,1,2,15v-5H1.62A1.72,1.72,0,0,1,.5,9.48,1.45,1.45,0,0,1,.36,7.43L.5,7.3h0L8,.45a1.83,1.83,0,0,1,2.4,0L18,7.3a1.44,1.44,0,0,1,.15,2L18,9.48a1.76,1.76,0,0,1-1.2.46h-.28v5A1.91,1.91,0,0,1,14.48,16.78ZM8.35,10.53H10.1a1.91,1.91,0,0,1,2,1.81v3.45h2.4a.86.86,0,0,0,.9-.82V9.44A.52.52,0,0,1,15.93,9h.82a.66.66,0,0,0,.44-.17.52.52,0,0,0,0-.74l0,0L9.66,1.15a.66.66,0,0,0-.87,0L1.26,8a.53.53,0,0,0,0,.8A.63.63,0,0,0,1.68,9h.83a.53.53,0,0,1,.54.49V15A.87.87,0,0,0,4,15.8H6.37V12.34A1.9,1.9,0,0,1,8.35,10.53Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.b096c815db4bbac937f4155a33a77845.svg";
export { ForwardRef as ReactComponent };